import { AnimationTypography } from '@/components/shared/atoms';

interface TitleProps {
  title: string;
  subTitle: string;
}

const Title = ({ title, subTitle }: TitleProps) => {
  return (
    <div className="flex flex-col w-full max-w-[1440px] mx-auto pl-[90px] pt-20 pb-[60px]">
      <AnimationTypography as="h1" type="fade-in-up" distance="16px" delay="200ms" className="text-display2Medium text-coolNeutral-5 pb-6">
        {title}
      </AnimationTypography>
      <AnimationTypography type="fade-in-up" distance="16px" delay="200ms" className="text-headline3Regular text-coolNeutral-17">
        {subTitle}
      </AnimationTypography>
    </div>
  );
};

export default Title;
